/**
 * Created by Z207644 on 11/6/2016.
 */
angular.module('cvsApp').service('getPatientInfoFromRxService',['networkService', 'xdrService', 'patientInfoFromRxDetailsModel', 'configManager','itemCartModel', function (NS, XS, PIRDM, CM, ICM) {

    function getPatientInfoFromRxService (){
        this.getPatientInfoFromRx = function(callBackSuccess,guestTokenID){
            //get url
            // var tokenId=cvsUtility.queryMap.tokenId?cvsUtility.queryMap.tokenId:guestTokenID;
            // var tokenType="Guest";
            /**
             * SP 11/20/2016 - ITPR015400 - Guest Refill
             * Modified service call to use version 2
             */
            var url = CM.getApiUrlWithApikeyV2('GET_PATIENT_INFO_RX_HISTORY_DETAILS');
            var request = {url:url,
                header:{
                "accept": "application/xml",
                "Content-Type":"application/xml"},
                data: getRequestBody(),
                onSuccess:callBackSuccess
            }
            cvsUtility.commonServiceCode(url,"getPatientInfoFromRx",PIRDM,request,callBackSuccess,NS);

        }
    }
    /**
     * SP 11/20/2016 - ITPR015400 - Guest Refill
     * Modified function to prepare request json object from ICM guestRxEnquiry
     */
    var getRequestBody = function(){
        var guestRxEnquiry = ICM.getGuestRxEnquiry();
        var requestJson = {request:{
            rxNumber:guestRxEnquiry.rxNumber,
            dispensingHbsSiteId:guestRxEnquiry.dispensingDetails.dispensinghbssiteid,
            dispensingCatsBranchId:guestRxEnquiry.dispensingDetails.dispensingcatsbranchid,
            dob: guestRxEnquiry.dob
        }
        }

        return cvsUtility.JSONToXml(requestJson);


    }

    return new getPatientInfoFromRxService();
}]);

